export class AmministrazioneNonIpaDTO {
  nomeEsteso: string;
  cfPi: string;
}
